import { FC } from 'react';
import { Link } from 'react-router-dom';
import i18next from 'i18next';
import styled from 'styled-components';

import SecondaryButton from '~src/shared/buttons/basicButtons/SecondaryButton.sc';

const FooterContainer = styled.div`
  margin-top: 60px;
  margin-bottom: 90px;
  padding: 30px 0;
  border-top: 1px solid ${({ theme }) => theme.black.a1};
`;

const InfoText = styled.div`
  font-size: 21px;
  text-align: center;
  color: ${({ theme }) => theme.baseBlue.a10};
  margin-bottom: 1.5rem;
`;

const InfoButton = styled.div`
  display: flex;
  justify-content: center;
  text-align: center;
`;

interface Props {
  t: i18next.TFunction;
  infoKey: string;
  infoTxt?: string;
  btnKey: string;
  linkUrl: string;
}

const TextBtnPageFooter: FC<Props> = ({ t, infoKey, infoTxt, btnKey, linkUrl }) => (
  <FooterContainer>
    <InfoText data-translation={infoKey}>{infoTxt || t(infoKey)}</InfoText>
    <InfoButton>
      <Link to={linkUrl}>
        <SecondaryButton $buttonSize="large">
          <span data-translation={btnKey}>{t(btnKey)}</span>
        </SecondaryButton>
      </Link>
    </InfoButton>
  </FooterContainer>
);

export default TextBtnPageFooter;
